import { useEffect, useState } from "react";

/**
 * Live mobile/tablet check for inspection capture gates.
 *
 * Do NOT use react-device-detect's cached `isMobile` — Chrome DevTools device
 * mode changes `navigator.userAgent` without a reload, but the library keeps
 * the value from first import. That left desktop sessions stuck in mobile UI
 * after closing device emulation.
 */
export function isMobilePhotoDevice() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  const ua = navigator.userAgent || navigator.vendor || "";

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(
      ua
    )
  ) {
    return true;
  }

  // iPadOS 13+ can report a desktop Mac UA while still being a tablet.
  if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) {
    return true;
  }

  return false;
}

export function useMobilePhotoDevice() {
  const [isMobileDevice, setIsMobileDevice] = useState(isMobilePhotoDevice);

  useEffect(() => {
    const sync = () => setIsMobileDevice(isMobilePhotoDevice());

    sync();
    window.addEventListener("resize", sync);
    window.addEventListener("orientationchange", sync);
    window.visualViewport?.addEventListener("resize", sync);

    let media;
    try {
      media = window.matchMedia("(pointer: coarse)");
      if (media.addEventListener) media.addEventListener("change", sync);
      else if (media.addListener) media.addListener(sync);
    } catch {
      media = null;
    }

    return () => {
      window.removeEventListener("resize", sync);
      window.removeEventListener("orientationchange", sync);
      window.visualViewport?.removeEventListener("resize", sync);
      if (media?.removeEventListener) media.removeEventListener("change", sync);
      else if (media?.removeListener) media.removeListener(sync);
    };
  }, []);

  return isMobileDevice;
}
